const warningThresholdHours = 9;
const dangerThresholdHours = 12;

export const getTimeOfDeathBgColor = (hoursSinceTOD: number | undefined) => {
    if (hoursSinceTOD === undefined) return "warning";
    if (hoursSinceTOD < warningThresholdHours) {
        return "success";
    } else if (hoursSinceTOD < dangerThresholdHours) {
        return "warning";
    } else {
        return "danger";
    }
};
